import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';
import LanguageDetector from 'i18next-browser-languagedetector';

// English translations
import commonEN from './locales/en/common.json';
import homeEN from './locales/en/home.json';
import aboutEN from './locales/en/about.json';
import contactEN from './locales/en/contact.json';
import websiteDevEN from './locales/en/websiteDev.json';
import webAppDevEN from './locales/en/webAppDev.json';
import seoPerfEN from './locales/en/seoPerf.json';
import notFoundEN from './locales/en/notFound.json';
import pricingEN from './locales/en/pricing.json';

// Dutch translations
import commonNL from './locales/nl/common.json';
import homeNL from './locales/nl/home.json';
import aboutNL from './locales/nl/about.json';
import contactNL from './locales/nl/contact.json';
import websiteDevNL from './locales/nl/websiteDev.json';
import webAppDevNL from './locales/nl/webAppDev.json';
import seoPerfNL from './locales/nl/seoPerf.json';
import notFoundNL from './locales/nl/notFound.json';
import pricingNL from './locales/nl/pricing.json';

const resources = {
  en: {
    common: commonEN,
    home: homeEN,
    about: aboutEN,
    contact: contactEN,
    websiteDev: websiteDevEN,
    webAppDev: webAppDevEN,
    seoPerf: seoPerfEN,
    notFound: notFoundEN,
    pricing: pricingEN,
  },
  nl: {
    common: commonNL,
    home: homeNL,
    about: aboutNL,
    contact: contactNL,
    websiteDev: websiteDevNL,
    webAppDev: webAppDevNL,
    seoPerf: seoPerfNL,
    notFound: notFoundNL,
    pricing: pricingNL,
  },
};

i18n
  .use(LanguageDetector)
  .use(initReactI18next)
  .init({
    resources,
    fallbackLng: 'en',
    defaultNS: 'common',
    ns: ['common', 'home', 'about', 'contact', 'websiteDev', 'webAppDev', 'seoPerf', 'notFound', 'pricing'],
    detection: {
      order: ['localStorage', 'navigator', 'htmlTag'],
      caches: ['localStorage'],
      lookupLocalStorage: 'craftech-language',
    },
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
